import woodspoon from './img/wood_spoons.jpg';
import rastabag from './img/rasta_bag.jpg';
import teaset from './img/tea_set.jpg';
import slippaz from './img/orange_slippers.jpg';
import birdpillow from './img/bird_pillow.jpg';
import woodbracelet from './img/wood_bracelet.jpg';
import calabash from './img/calabash_container.jpg';
import necklace from './img/necklace.jpg';
import cartoonpins from './img/cartoon_pins.jpg';

import ministringflag from './img/ministringflag.jpg';
import hooragflag from './img/hooragflag.jpg';
import longsleevezipup from './img/longsleevezipup.png';
import cottonbalaclava from './img/cottonbalaclava.png';
import baseballcap from './img/baseballcap.png';
import footballscarf from './img/footballscarf.png';
import deskflag from './img/deskflag.jpg';
import liquidextract from './img/liquidextract.jpg';
import costumesunglasses from './img/costumesunglasses.jpg';
import islandspicejerk from './img/islandspicejerk.jpg';
import jablumcoffee from './img/jablumcoffee.jpg';
import dominotable from './img/dominotable.jpg';
import flagboxers from './img/flagboxers.png';
import rastabracelet from './img/rastabracelet.png';
import flagboxinggloves from './img/flagboxinggloves.jpg';
import umbrojersey from './img/umbrojersey.jpg';
import bandanasoft from './img/bandanasoft.png';
import haymancoffee from './img/haymancoffee.jpg';
import guitarstrap from './img/guitarstrap.jpg';
import flaglicense from './img/flaglicense.jpg';
import sprintermovie from './img/sprintermovie.jpg';
import jablumpremium from './img/jablumpremium.jpg';
import mousepad from './img/mousepad.jpg';
import cyclingjersey from './img/cyclingjersey.jpg';
import dreadextensions from './img/dreadextensions.jpg';
import flag3x5 from './img/flag3x5.jpg';
import castorhairoil from './img/castorhairoil.jpg';
import haymancoffeepods from './img/haymancoffeepods.jpg';
import flagbrassgrommets from './img/flagbrassgrommets.jpg';
import bumpersticker from './img/bumpersticker.jpg';
import ethiopiaearrings from './img/ethiopiaearrings.jpg';
import thickflag from './img/thickflag.jpg';
import umbrohomejersey from './img/umbrohomejersey.png';
import yellowonepiece from './img/yellowonepiece.png';
import floralonepiece from './img/floralonepiece.png';
import purpleonepiece from './img/purpleonepiece.png';
import flagblanket from './img/flagblanket.jpg';
import rastabeanie from './img/rastabeanie.png';
import boxinggloves from './img/boxinggloves.jpg';
import windowflag from './img/windowflag.jpg';
import cafebluecoffee from './img/cafebluecoffee.jpg';
import blackdreadextension from './img/blackdreadextension.jpg';
import flagpatches from './img/flagpatches.jpg';
import skulldecal from './img/skulldecal.jpg';
import magnumexotics from './img/magnumexotics.jpg';
import ultimatetour from './img/ultimatetour.jpg';
import steellicense from './img/steellicense.jpg';
import weedshower from './img/weedshower.jpg';
import hammock from './img/hammock.jpg';
import lionsunshade from './img/lionsunshade.jpg';
import basketballjersey from './img/basketballjersey.png';
import cyclingjerseywomen from './img/cyclingjerseywomen.jpg';
import vinyldecal from './img/vinyldecal.jpg';
import fridgemagnet from './img/fridgemagnet.jpg';
import lemonpepperspice from './img/lemonpepperspice.jpg';
import rastaknapsack from './img/rastaknapsack.png';
import yardiemovie from './img/yardiemovie.jpg';
import goodvibesmenshirt from './img/goodvibesmenshirt.png';
import goodvibeswomenshirt from './img/goodvibeswomenshirt.png';
import rastahatdreadlocks from './img/rastahatdreadlocks.png';
import surfgirls from './img/surfgirls.jpg';
import kingstonparadise from './img/kingstonparadise.jpg';
import jamaicachain from './img/jamaicachain.png';
import handflags from './img/handflags.jpg';
import coolingsleeves from './img/coolingsleeves.jpg';
import femalelongshirt from './img/femalelongshirt.png';
import rastafishnet from './img/rastafishnet.png';
import rastaumbrelladress from './img/rastaumbrelladress.png';
import jamaicamistake from './img/jamaicamistake.jpg';
import onepeoplebook from './img/onepeoplebook.png';
import mapmagnet from './img/mapmagnet.jpg';


//mock data structure; array of objects (products) 


const ProductJSON = 



[
    {
      "id": 1,
      "title": "Clay Vase with Wooden Utensils",
      "seller": "Wood n Wata",
      "rating": 4,
      "ratings": 543,
      "price": 99.95,
      "img": woodspoon,
      "cartquantity": 0,
      "giftcat": ['weddinggifts'],
      "instock": 65,
      "categories": ['miscellaneous', 'home'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 4355
    },
    {
      "id": 2,
      "title": "Rasta Colour Handbag",
      "seller": "Dappa Doops",
      "rating": 5,
      "ratings": 2443,
      "price": 50.25,
      "img": rastabag,
      "cartquantity": 0,
      "giftcat": ['giftsforher'],
      "instock": 456,
      "categories": ['clothing&apparel', 'accessories', 'bags&knapsacks'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 5434
    },
    {
      "id": 3,
      "title": "Clay Tea Set",
      "seller": "Blacks from Bogwalk",
      "rating": 4,
      "ratings": 2122,
      "price": 119.99,
      "img": teaset,
      "cartquantity": 0,
      "giftcat": ['weddinggifts'],
      "instock": 45,
      "categories": ['miscellaneous', 'home', 'kitchen'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 6544
    },
    {
      "id": 4,
      "title": "Orange Sandals (pair)",
      "seller": "Peenie Wallie",
      "rating": 3,
      "ratings": 543,
      "price": 22,
      "img": slippaz,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 65,
      "categories": ['clothing&apparel', 'women', 'shoes', 'sandals'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 5622
    },
    {
      "id": 5,
      "title": "Hummingbird Pillow",
      "seller": "Toni '2 cute' Clarke",
      "rating": 5,
      "ratings": 155,
      "price": 25,
      "img": birdpillow,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 4,
      "categories": ['miscellaneous', 'home', 'living_room'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 5648
    },
    {
      "id": 6,
      "title": "Wooden Bracelet",
      "seller": "Itchi Hanmiggle",
      "rating": 4,
      "ratings": 1432,
      "price": 12.5,
      "img": woodbracelet,
      "cartquantity": 0,
      "giftcat": ['giftsforher', 'giftsforhim'],
      "instock": 2,
      "categories": ['arts&crafts', 'jewellery', 'bracelets'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 4345
    },
    {
      "id": 7,
      "title": "Calabash Container Set",
      "seller": "Ricky 'Stinky' McCaw",
      "rating": 3,
      "ratings": 906,
      "price": 60,
      "img": calabash,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 0,
      "categories": ['arts&crafts', 'knick_knacks'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 5345
    },
    {
      "id": 8,
      "title": "Brown Pendant Necklace",
      "seller": "Kimmy Creates",
      "rating": 5,
      "ratings": 3255,
      "price": 15.25,
      "img": necklace,
      "cartquantity": 0,
      "giftcat": ['giftsforher'],
      "instock": 65,
      "categories": ['arts&crafts', 'jewellery', 'necklaces'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 4532
    },
    {
      "id": 9,
      "title": "Cartoon Pins Set",
      "seller": "Trixie's Treats",
      "rating": 4,
      "ratings": 2189,
      "price": 9.99,
      "img": cartoonpins,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 7,
      "categories": ['arts&crafts', 'knick_knacks'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 8456
    },
    {
      "id": 10,
      "title": "Small Jamaican Flags Banner",
      "seller": "Kimmy Creates",
      "rating": 3,
      "ratings": 255,
      "price": 8.25,
      "img": ministringflag,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 34,
      "categories": ['miscellaneous', 'flags'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 998
    },
    {
      "id": 11,
      "title": "Moisture Wicking Bandana",
      "seller": "Blacks from Bogwalk",
      "rating": 5,
      "ratings": 342,
      "price": 19.75,
      "img": hooragflag,
      "cartquantity": 0,
      "giftcat": ['giftsforhim'],
      "instock": 0,
      "categories": ['clothing&apparel', 'accessories', 'masks'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 876
    },
    {
      "id": 12,
      "title": "Long Sleeve Zip Up",
      "seller": "Peenie Wallie",
      "rating": 4,
      "ratings": 2345,
      "price": 71.99,
      "img": longsleevezipup,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 543,
      "categories": ['clothing&apparel', 'men', 'sweaters'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 677
    },
    {
      "id": 13,
      "title": "Cotton Balaclava Face Cover",
      "seller": "Wood n Wata",
      "rating": 5,
      "ratings": 1643,
      "price": 12.15,
      "img": cottonbalaclava,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 3,
      "categories": ['clothing&apparel', 'accessories', 'masks'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 456
    },
    {
      "id": 14,
      "title": "High Quality Adjustable Baseball Cap",
      "seller": "Itchi Hanmiggle",
      "rating": 4,
      "ratings": 232,
      "price": 24.99,
      "img": baseballcap,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 34,
      "categories": ['clothing&apparel', 'hats&scarfs'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 54
    },
    {
      "id": 15,
      "title": "Jamaica Football Knit Scarf",
      "seller": "Blacks from Bogwalk",
      "rating": 4,
      "ratings": 122,
      "price": 17.95,
      "img": footballscarf,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 2,
      "categories": ['clothing&apparel', 'hats&scarfs'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 545
    },
    {
      "id": 16,
      "title": "Office Table Flag",
      "seller": "Dappa Doops",
      "rating": 3,
      "ratings": 208,
      "price": 9.99,
      "img": deskflag,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 356,
      "categories": ['miscellaneous', 'flags'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 34
    },
    {
      "id": 17,
      "title": "Dogwood Liquid Extract",
      "seller": "Toni '2 cute' Clarke",
      "rating": 4,
      "ratings": 2342,
      "price": 40.75,
      "img": liquidextract,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 75,
      "categories": ['food&drink', 'herbal_supplements'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 767
    },
    {
      "id": 18,
      "title": "Party Costume Sunglasses",
      "seller": "Peenie Wallie",
      "rating": 5,
      "ratings": 2334,
      "price": 9.99,
      "img": costumesunglasses,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 4,
      "categories": ['clothing&apparel', 'accessories', 'sunglasses'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 355
    },
    {
      "id": 19,
      "title": "Island Spice Jerk Seasoning",
      "seller": "Dappa Doops",
      "rating": 5,
      "ratings": 3242,
      "price": 14.99,
      "img": islandspicejerk,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 3,
      "categories": ['food&drink', 'sauces&seasoning'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 255
    },
    {
      "id": 20,
      "title": "Jablum Blue Mountain Coffee",
      "seller": "Wood n Wata",
      "rating": 5,
      "ratings": 2134,
      "price": 65,
      "img": jablumcoffee,
      "cartquantity": 0,
      "giftcat": ['weddinggifts', 'anniversarygifts'],
      "instock": 2,
      "categories": ['food&drink', 'coffee'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 921
    },
    {
      "id": 21,
      "title": "Wooden Domino Table",
      "seller": "Wood n Wata",
      "rating": 5,
      "ratings": 809,
      "price": 250,
      "img": dominotable,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 0,
      "categories": ['miscellaneous', 'home', 'living_room'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 468
    },
    {
      "id": 22,
      "title": "Flag Boxer Briefs",
      "seller": "Toni '2 cute' Clarke",
      "rating": 4,
      "ratings": 234,
      "price": 15.55,
      "img": flagboxers,
      "cartquantity": 0,
      "giftcat": ['giftsforhim'],
      "instock": 41,
      "categories": ['clothing&apparel', 'men', 'underwear&swimwear'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 873
    },
    {
      "id": 23,
      "title": "Handmade Rasta Bracelet",
      "seller": "Blacks from Bogwalk",
      "rating": 5,
      "ratings": 2398,
      "price": 18.25,
      "img": rastabracelet,
      "cartquantity": 0,
      "giftcat": ['giftsforher'],
      "instock": 3,
      "categories": ['arts&crafts', 'jewellery', 'bracelets'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 649
    },
    {
      "id": 24,
      "title": "Decorative Flag and Mini Boxing Gloves ",
      "seller": "Dappa Doops",
      "rating": 3,
      "ratings": 223,
      "price": 14.95,
      "img": flagboxinggloves,
      "cartquantity": 0,
      "giftcat": ['giftsforhim'],
      "instock": 0,
      "categories": ['miscellaneous', 'other'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 460
    },
    {
      "id": 25,
      "title": "Jamaica Home Jersey",
      "seller": "Itchi Hanmiggle",
      "rating": 4,
      "ratings": 3234,
      "price": 85.3,
      "img": umbrojersey,
      "cartquantity": 0,
      "giftcat": ['giftsforhim'],
      "instock": 6,
      "categories": ['clothing&apparel', 'men', 'shirts'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 796
    },
    {
      "id": 26,
      "title": "Soft Face Mack Bandana",
      "seller": "Toni '2 cute' Clarke",
      "rating": 5,
      "ratings": 2322,
      "price": 12.55,
      "img": bandanasoft,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 0,
      "categories": ['clothing&apparel', 'accessories', 'masks'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 358
    },
    {
      "id": 27,
      "title": "Hayman Blue Mountain Coffee",
      "seller": "Blacks from Bogwalk",
      "rating": 5,
      "ratings": 1028,
      "price": 79.95,
      "img": haymancoffee,
      "cartquantity": 0,
      "giftcat": ['weddinggifts', 'anniversarygifts'],
      "instock": 7,
      "categories": ['food&drink', 'coffee'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 959
    },
    {
      "id": 28,
      "title": "Rasta Guitar Strap",
      "seller": "Wood n Wata",
      "rating": 5,
      "ratings": 223,
      "price": 18.55,
      "img": guitarstrap,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 0,
      "categories": ['miscellaneous', 'other'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 467
    },
    {
      "id": 29,
      "title": "Flag License Plate Frame",
      "seller": "Kimmy Creates",
      "rating": 3,
      "ratings": 133,
      "price": 14.99,
      "img": flaglicense,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 0,
      "categories": ['miscellaneous', 'other'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 973
    },
    {
      "id": 30,
      "title": "Sprinter ",
      "seller": "Peenie Wallie",
      "rating": 4,
      "ratings": 450,
      "price": 9.99,
      "img": sprintermovie,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 45,
      "categories": ['books&entertainment', 'movies', 'fiction'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 675
    },
    {
      "id": 31,
      "title": "Jablum Premium Blend Coffee",
      "seller": "Dappa Doops",
      "rating": 4,
      "ratings": 743,
      "price": 55.95,
      "img": jablumpremium,
      "cartquantity": 0,
      "giftcat": ['weddinggifts', 'anniversarygifts'],
      "instock": 0,
      "categories": ['food&drink', 'coffee'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 963
    },
    {
      "id": 32,
      "title": "Flag Mouse Pad",
      "seller": "Ricky 'Stinky' McCaw",
      "rating": 3,
      "ratings": 1293,
      "price": 7.89,
      "img": mousepad,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 7,
      "categories": ['miscellaneous', 'other'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 689
    },
    {
      "id": 33,
      "title": "Team Jamaica Cycling Jersey",
      "seller": "Itchi Hanmiggle",
      "rating": 4,
      "ratings": 327,
      "price": 56.35,
      "img": cyclingjersey,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 6,
      "categories": ['clothing&apparel', 'men', 'shirts'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 986
    },
    {
      "id": 34,
      "title": "Black to Blonde Dreadlock Extensions",
      "seller": "Wood n Wata",
      "rating": 5,
      "ratings": 2451,
      "price": 15.99,
      "img": dreadextensions,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 0,
      "categories": ['miscellaneous', 'hair', 'extensions'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 479
    },
    {
      "id": 35,
      "title": "3 x 5 Feet Polyester Flag",
      "seller": "Trixie's Treats",
      "rating": 5,
      "ratings": 231,
      "price": 7.23,
      "img": flag3x5,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 45,
      "categories": ['miscellaneous', 'flags'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 163
    },
    {
      "id": 36,
      "title": "Pure Cold_Pressed Castor Oil",
      "seller": "Dappa Doops",
      "rating": 5,
      "ratings": 7384,
      "price": 14.95,
      "img": castorhairoil,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 35,
      "categories": ['miscellaneous', 'hair', 'haircare_products'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 197
    },
    {
      "id": 37,
      "title": "Hayman Blue Mountain Nespresso Pods",
      "seller": "Blacks from Bogwalk",
      "rating": 4,
      "ratings": 732,
      "price": 69.99,
      "img": haymancoffeepods,
      "cartquantity": 0,
      "giftcat": ['weddinggifts', 'anniversarygifts'],
      "instock": 0,
      "categories": ['food&drink', 'coffee'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 53
    },
    {
      "id": 38,
      "title": "3 x 5 Feet Flag with Brass Grommets",
      "seller": "Peenie Wallie",
      "rating": 5,
      "ratings": 98,
      "price": 6.32,
      "img": flagbrassgrommets,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 2,
      "categories": ['miscellaneous', 'flags'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 693
    },
    {
      "id": 39,
      "title": "Flag Bumper Sticker Decal",
      "seller": "Blacks from Bogwalk",
      "rating": 5,
      "ratings": 234,
      "price": 9.99,
      "img": bumpersticker,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 553,
      "categories": ['miscellaneous', 'other'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 529
    },
    {
      "id": 40,
      "title": "Ethiopia Santeem Coin Earrings",
      "seller": "Itchi Hanmiggle",
      "rating": 5,
      "ratings": 3244,
      "price": 85.95,
      "img": ethiopiaearrings,
      "cartquantity": 0,
      "giftcat": ['anniversarygifts'],
      "instock": 5,
      "categories": ['arts&crafts', 'jewellery', 'earrings'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 537
    },
    {
      "id": 41,
      "title": "3 x 5 feet Indoor and Outdoor Flag with Grommets",
      "seller": "Dappa Doops",
      "rating": 5,
      "ratings": 102,
      "price": 10.99,
      "img": thickflag,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 43,
      "categories": ['miscellaneous', 'flags'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 439
    },
    {
      "id": 42,
      "title": "Umbro Home Football Jersey",
      "seller": "Wood n Wata",
      "rating": 5,
      "ratings": 2683,
      "price": 69.94,
      "img": umbrohomejersey,
      "cartquantity": 0,
      "giftcat": ['giftsforhim'],
      "instock": 64,
      "categories": ['clothing&apparel', 'men', 'shirts'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 632
    },
    {
      "id": 43,
      "title": "Yellow One Piece Lace Swimsuit",
      "seller": "Ricky 'Stinky' McCaw",
      "rating": 4,
      "ratings": 3728,
      "price": 25.87,
      "img": yellowonepiece,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 3,
      "categories": ['clothing&apparel', 'women', 'underwear&swimwear'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 82
    },
    {
      "id": 44,
      "title": "Floral One Piece Lace Swimsuit",
      "seller": "Peenie Wallie",
      "rating": 5,
      "ratings": 2884,
      "price": 25.99,
      "img": floralonepiece,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 455,
      "categories": ['clothing&apparel', 'women', 'underwear&swimwear'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 1003
    },
    {
      "id": 45,
      "title": "Purple One Piece Lace Swimsuit",
      "seller": "Kimmy Creates",
      "rating": 5,
      "ratings": 1830,
      "price": 25.55,
      "img": purpleonepiece,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 523,
      "categories": ['clothing&apparel', 'women', 'underwear&swimwear'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 452
    },
    {
      "id": 46,
      "title": "Fleece Flag Blanket",
      "seller": "Toni '2 cute' Clarke",
      "rating": 4,
      "ratings": 2398,
      "price": 28.95,
      "img": flagblanket,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 54,
      "categories": ['miscellaneous', 'home', 'bedroom'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 950
    },
    {
      "id": 47,
      "title": "Rasta Stripe Oversized Hat",
      "seller": "Dappa Doops",
      "rating": 4,
      "ratings": 643,
      "price": 12.55,
      "img": rastabeanie,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 3,
      "categories": ['clothing&apparel', 'hats&scarfs'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 482
    },
    {
      "id": 48,
      "title": "Boxing Gloves",
      "seller": "Itchi Hanmiggle",
      "rating": 3,
      "ratings": 324,
      "price": 9.75,
      "img": boxinggloves,
      "cartquantity": 0,
      "giftcat": ['giftsforhim'],
      "instock": 454,
      "categories": ['miscellaneous', 'other'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 12
    },
    {
      "id": 49,
      "title": "Window Hanging Flag",
      "seller": "Blacks from Bogwalk",
      "rating": 4,
      "ratings": 2144,
      "price": 6.99,
      "img": windowflag,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 39,
      "categories": ['miscellaneous', 'flags'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 725
    },
    {
      "id": 50,
      "title": "Caf  Blue Blue Mountain Coffee",
      "seller": "Dappa Doops",
      "rating": 5,
      "ratings": 553,
      "price": 48.99,
      "img": cafebluecoffee,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 455,
      "categories": ['food&drink', 'coffee'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 75
    },
    {
      "id": 51,
      "title": "10 Strands of Black Backcomb Dread Extensions",
      "seller": "Peenie Wallie",
      "rating": 4,
      "ratings": 7654,
      "price": 11.99,
      "img": blackdreadextension,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 43,
      "categories": ['miscellaneous', 'hair', 'extensions'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 97
    },
    {
      "id": 52,
      "title": "3.5 x 2.25 inch flag patches (3)",
      "seller": "Kimmy Creates",
      "rating": 5,
      "ratings": 221,
      "price": 9.99,
      "img": flagpatches,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 543,
      "categories": ['miscellaneous', 'flags'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 652
    },
    {
      "id": 53,
      "title": "Skull Bumper Sticker",
      "seller": "Wood n Wata",
      "rating": 2,
      "ratings": 3234,
      "price": 9.99,
      "img": skulldecal,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 45,
      "categories": ['miscellaneous', 'other'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 303
    },
    {
      "id": 54,
      "title": "Magnum Exotics Blue Mountain Coffee",
      "seller": "Dappa Doops",
      "rating": 3,
      "ratings": 291,
      "price": 34.95,
      "img": magnumexotics,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 543,
      "categories": ['food&drink', 'coffee'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 647
    },
    {
      "id": 55,
      "title": "Jamaica: The Ultimate Tour",
      "seller": "Ricky 'Stinky' McCaw",
      "rating": 4,
      "ratings": 2145,
      "price": 9.99,
      "img": ultimatetour,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 45,
      "categories": ['books&entertainment', 'movies', 'non-fiction'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 562
    },
    {
      "id": 56,
      "title": "Heavy Duty Steel License Plate",
      "seller": "Itchi Hanmiggle",
      "rating": 5,
      "ratings": 3255,
      "price": 16.74,
      "img": steellicense,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 43,
      "categories": ['miscellaneous', 'other'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 92
    },
    {
      "id": 57,
      "title": "Marijuana Leaf Shower Curtain",
      "seller": "Wood n Wata",
      "rating": 5,
      "ratings": 2093,
      "price": 19.99,
      "img": weedshower,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 543,
      "categories": ['miscellaneous', 'home', 'bathroom'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 163
    },
    {
      "id": 58,
      "title": "Single Cotton Hammock",
      "seller": "Toni '2 cute' Clarke",
      "rating": 4,
      "ratings": 2924,
      "price": 16.13,
      "img": hammock,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 2,
      "categories": ['miscellaneous', 'home'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 467
    },
    {
      "id": 59,
      "title": "Lion Sun Heat Shield for Cars",
      "seller": "Trixie's Treats",
      "rating": 5,
      "ratings": 1024,
      "price": 25.86,
      "img": lionsunshade,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 0,
      "categories": ['miscellaneous', 'other'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 348
    },
    {
      "id": 60,
      "title": "Rasta Basketball Jersey",
      "seller": "Blacks from Bogwalk",
      "rating": 5,
      "ratings": 3271,
      "price": 49.99,
      "img": basketballjersey,
      "cartquantity": 0,
      "giftcat": ['giftsforhim'],
      "instock": 0,
      "categories": ['clothing&apparel', 'men', 'shirts'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 457
    },
    {
      "id": 61,
      "title": "Green Cycling Jersey",
      "seller": "Trixie's Treats",
      "rating": 4,
      "ratings": 3944,
      "price": 33.99,
      "img": cyclingjerseywomen,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 34,
      "categories": ['clothing&apparel', 'women', 'shirts'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 293
    },
    {
      "id": 62,
      "title": "Rasta Palm Tree Vinyl Decal Sticker",
      "seller": "Peenie Wallie",
      "rating": 5,
      "ratings": 632,
      "price": 9.25,
      "img": vinyldecal,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 5,
      "categories": ['miscellaneous', 'other'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 428
    },
    {
      "id": 63,
      "title": "Rasta Slipper Refrigerator Magnet",
      "seller": "Wood n Wata",
      "rating": 3,
      "ratings": 233,
      "price": 8.32,
      "img": fridgemagnet,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 3,
      "categories": ['miscellaneous', 'other'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 625
    },
    {
      "id": 64,
      "title": "Johnny's Lemon Pepper Seasoning",
      "seller": "Trixie's Treats",
      "rating": 3,
      "ratings": 927,
      "price": 26.75,
      "img": lemonpepperspice,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 0,
      "categories": ['food&drink', 'sauces&seasoning'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 571
    },
    {
      "id": 65,
      "title": "Rasta Canvas Bag Pack",
      "seller": "Ricky 'Stinky' McCaw",
      "rating": 4,
      "ratings": 676,
      "price": 18.95,
      "img": rastaknapsack,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 24,
      "categories": ['clothing&apparel', 'accessories', 'bags&knapsacks'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 284
    },
    {
      "id": 66,
      "title": "Yardie",
      "seller": "Dappa Doops",
      "rating": 5,
      "ratings": 423,
      "price": 12.99,
      "img": yardiemovie,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 0,
      "categories": ['books&entertainment', 'movies', 'fiction'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 471
    },
    {
      "id": 67,
      "title": "Good Vibes Only Rasta Shirt",
      "seller": "Blacks from Bogwalk",
      "rating": 5,
      "ratings": 4363,
      "price": 14.99,
      "img": goodvibesmenshirt,
      "cartquantity": 0,
      "giftcat": ['giftsforhim'],
      "instock": 3,
      "categories": ['clothing&apparel', 'men', 'shirts'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 238
    },
    {
      "id": 68,
      "title": "Good Vibes Only Rasta Shirt",
      "seller": "Itchi Hanmiggle",
      "rating": 5,
      "ratings": 5473,
      "price": 14.99,
      "img": goodvibeswomenshirt,
      "cartquantity": 0,
      "giftcat": ['giftsforher'],
      "instock": 0,
      "categories": ['clothing&apparel', 'women', 'shirts'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 978
    },
    {
      "id": 69,
      "title": "Costume Rasta Hat with Dreadlocks",
      "seller": "Dappa Doops",
      "rating": 4,
      "ratings": 6343,
      "price": 11.99,
      "img": rastahatdreadlocks,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 536,
      "categories": ['clothing&apparel', 'hats&scarfs'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 1054
    },
    {
      "id": 70,
      "title": "Surf Girls Jamaica",
      "seller": "Peenie Wallie",
      "rating": 5,
      "ratings": 972,
      "price": 10.99,
      "img": surfgirls,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 4,
      "categories": ['books&entertainment', 'movies', 'non-fiction'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 654
    },
    {
      "id": 71,
      "title": "Kingston Paradise",
      "seller": "Wood n Wata",
      "rating": 4,
      "ratings": 323,
      "price": 9.99,
      "img": kingstonparadise,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 5,
      "categories": ['books&entertainment', 'movies', 'fiction'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 179
    },
    {
      "id": 72,
      "title": "Stainless Steel Map of Jamaica Chain",
      "seller": "Peenie Wallie",
      "rating": 5,
      "ratings": 2038,
      "price": 7.84,
      "img": jamaicachain,
      "cartquantity": 0,
      "giftcat": ['anniversarygifts'],
      "instock": 0,
      "categories": ['arts&crafts', 'jewellery', 'necklaces'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 318
    },
    {
      "id": 73,
      "title": "Dozen Hand Held Flags",
      "seller": "Dappa Doops",
      "rating": 4,
      "ratings": 322,
      "price": 5.44,
      "img": handflags,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 34,
      "categories": ['miscellaneous', 'flags'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 796
    },
    {
      "id": 74,
      "title": "Flag Cooling Arm Sleeves",
      "seller": "Toni '2 cute' Clarke",
      "rating": 5,
      "ratings": 3525,
      "price": 12.96,
      "img": coolingsleeves,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 0,
      "categories": ['clothing&apparel', 'men'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 145
    },
    {
      "id": 75,
      "title": "Flag Nightshirt ",
      "seller": "Blacks from Bogwalk",
      "rating": 4,
      "ratings": 1027,
      "price": 23.78,
      "img": femalelongshirt,
      "cartquantity": 0,
      "giftcat": ['giftsforher'],
      "instock": 343,
      "categories": ['clothing&apparel', 'women', 'shirts'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 985
    },
    {
      "id": 76,
      "title": "Spaghetti Strap Rasta Fishnet Shirt",
      "seller": "Peenie Wallie",
      "rating": 5,
      "ratings": 738,
      "price": 26.73,
      "img": rastafishnet,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 28,
      "categories": ['clothing&apparel', 'women', 'shirts'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 957
    },
    {
      "id": 77,
      "title": "Rasta Sun Dress",
      "seller": "Wood n Wata",
      "rating": 5,
      "ratings": 4533,
      "price": 21.45,
      "img": rastaumbrelladress,
      "cartquantity": 0,
      "giftcat": ['giftsforher'],
      "instock": 54,
      "categories": ['clothing&apparel', 'women', 'shirts'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 63
    },
    {
      "id": 78,
      "title": "Jamaica Mistake Dressing",
      "seller": "Trixie's Treats",
      "rating": 4,
      "ratings": 287,
      "price": 17.83,
      "img": jamaicamistake,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 4,
      "categories": ['food&drink', 'sauces&seasoning'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 886
    },
    {
      "id": 79,
      "title": "Out of Many, One People: The Story Of Jamaica Illustrated",
      "seller": "Dappa Doops",
      "rating": 4,
      "ratings": 543,
      "price": 13.99,
      "img": onepeoplebook,
      "cartquantity": 0,
      "giftcat": ['anniversarygifts'],
      "instock": 45,
      "categories": ['books&entertainment', 'books', 'non-fiction'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 174
    },
    {
      "id": 80,
      "title": "Map Refrigerator Magnet",
      "seller": "Wood n Wata",
      "rating": 4,
      "ratings": 89,
      "price": 8.43,
      "img": mapmagnet,
      "cartquantity": 0,
      "giftcat": "",
      "instock": 836,
      "categories": ['miscellaneous', 'other'],
      "keywords": "",
      "extra": "",
      "personalize": "",
      "description": "",
      "reviews": "",
      "modifiers": "",
      "itemsold": 130
    }
   ]



export default ProductJSON;
